<svelte:options customElement="weecareenrollment-main" />

<script>
	import { onMount } from "svelte";
	import { loadAssets } from "../../../../../SharedSvelte/Common.svelte";
	//import { weeCareEnrollmentState } from "../../state/ApplicationState.svelte";
	import WeeCareEnrollment from './WeeCareEnrollment.svelte';
	//import GlobalLoader from "../../../../../SharedSvelte/GlobalLoader.svelte";

	onMount(() => {
		setTimeout(() => {
		loadAssets("weecareenrollment-main");
		// setTimeout( function() { fetchWeeCareEnrollmentContent() }, 100 );
		}, 10);
	});
</script>

<WeeCareEnrollment />

<!-- <GlobalLoader /> -->